import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import Menu from './Menu.js';
import LocalizationMenu from './LocalizationMenu.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      LocalizationMenu,
    },
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 128;

    toggleClass(document.documentElement, 'is-on-top', isOnTop);
    toggleClass(document.documentElement, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.documentElement, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.documentElement, 'is-scrolling-up', direction.y === 'UP');
  }

  /**
   * Listen to any menu open.
   */
  onMenuOpen() {
    this.updateMenuState();
  }

  /**
   * Listen to any close menu.
   */
  onMenuClose() {
    this.updateMenuState();
  }

  /**
   * Update the menu state on close or open.
   */
  updateMenuState() {
    let someMenuIsOpen = false;

    for (const menu of this.$children.Menu) {
      if (menu.$isMounted && menu.isOpen) {
        someMenuIsOpen = true;
        break;
      }
    }

    toggleClass(document.documentElement, 'is-menu-open', someMenuIsOpen);
  }
}
